<template>
  <div>
    <app-cells><h1 class="title">Meals reservations</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ReservationsMealsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-meals-upcoming', label: 'Upcoming' },
        { name: 'reservation-meals-archive', label: 'Archive' },
      ],
    }
  },
}
</script>
